import {
  Button,
  Grid,
  FormControl,
  Typography,
  Paper,
} from "@material-ui/core";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles, withTheme } from "@material-ui/core/styles";
import InputFormat from "../../../partials/inputForm";
import PropTypes from "prop-types";
import {
  CountryDropdown,
  DistrictDropdown,
  CityDropdown,
  WardDropdown,
} from "../../../partials/selectAddress";
import moment from "moment";
import Snackbar from "../../snackbar";
import { edit as styles } from "./styles";
import Loading from "../../loading";
import InputFileReader from "../../fileReader";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import SocialType from "../../../partials/socialType";
import SelectGender from "../../../partials/selectGender";
import SelectDateTime from "../../../partials/selectDateTime";
import SelectMultiUsedService from "../../../partials/selectMultiUsedService";
import SelectMultiInteresting from "../../../partials/selectMultiInteresting";
import { Link } from "react-router-dom";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "moment/locale/vi";
import "moment/locale/en-ca";
class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerData: {
        ...this.props.customerData,
      },
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.props.getAllMenuItem();
    this.props.getVoucher();
  }
  handleChangeDate = (value) => {
    let { customerData } = this.state;
    customerData["lastTime"] = value;

    this.setState({ customerData });
  };
  // openCustomerDetail(data) {
  //     this.props.history.push(`/customer/${data._id}`)
  // }
  handleSubmit = async () => {
    let customerData = this.state.customerData;
    this.loading.startLoading();
    let files = this.InputFileReader.getFile();
    let src = this.InputFileReader.getSrc();
    if (files !== null) {
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: files,
        code: customerData.customerMobile,
        imgPre: customerData.customerImage,
        type: "avatar-customer",
      });
      if (checkUpload.code === 1) {
        customerData.customerImage = checkUpload.data.previewLink;
      }
      this.handleEditCustomer(customerData);
    } else if (src !== null) {
      customerData.customerImage = src;
      this.handleEditCustomer(customerData);
    } else if (files === null && src === null) {
      if (customerData.customerImage && this.InputFileReader.getFlagEdit()) {
        // đang có hình ảnh trong database và đã thay đổi file upload hình ảnh
        customerData.customerImage = "";
      }
      this.handleEditCustomer(customerData);
    }
  };
  handleEditCustomer = async (customerData) => {
    let check = await this.props.customerDispatch.editCustomer(customerData);
    this.loading.stopLoading();
    this.props.afterFetch(check);
  };
  formatDate = (date) => {
    return moment(date).format("DD/MM/YYYY");
  };
  handleChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let { customerData } = this.state;
    customerData[name] = value;
    this.setState({ customerData });
  };

  removeAscent(str) {
    if (str === null || str === undefined) return str;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    return str;
  }

  handleCheck = () => {
    let { t } = this.props;
    let data = this.state.customerData;
    let validPhone = _parsePhoneNumber(data.countryCode, data.customerMobile)
      .isValid;
    if (!data.customerName || !data.customerMobile) {
      this.mSnackbar.handleClick(
        t("customer_addcustomer_please_fill_in_this_form"),
        "warning"
      );
    } else if (!validPhone) {
      this.mSnackbar.handleClick(
        t("customer_addcustomer_phone_number_is_not_valid"),
        "warning"
      );
    } else {
      this.handleSubmit();
    }
  };
  snackbar = (mess, type) => {
    this.mSnackbar.handleClick(mess, type);
  };

  handleGetValueUsedService = (value) => {
    let { customerData } = this.state;
    customerData["useServices"] = value;
    this.setState({ customerData });
  };

  handleGetValueInteresting = (value) => {
    let { customerData } = this.state;
    customerData["interesting"] = value;
    this.setState({ customerData });
  };
  handleChangeBirthDay = (name, date) => {
    let { customerData } = this.state;
    customerData[name] = date && date._isAMomentObject ? date.valueOf() : "";
    this.setState({ customerData });
  };
  render() {
    const { i18n, classes, t, allMenuItem = [] } = this.props;
    const { customerData } = this.state;
    return (
      <MuiPickersUtilsProvider
        libInstance={moment}
        utils={MomentUtils}
        locale={i18n.language === "vn" ? "vi" : "en"}
      >
        <Paper className={classes.editFormContainer} square={true}>
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <Loading onRef={(id) => (this.loading = id)} />
          <Grid container spacing={3}>
            {/* <Grid item sm={12} md={12}> */}
            {/* <Grid container spacing={3} justify='center' alignItems='center'> */}
            <Grid item xs={12} sm={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  <InputFileReader
                    onRef={(id) => (this.InputFileReader = id)}
                    style={classes}
                    defaultImg={customerData.customerImage}
                    selectStorageMode={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl}>
                    <label className={classes.label}>{t("Created At")}</label>
                    <Typography variant="body2">
                      {this.formatDate(customerData.createdAt)}
                    </Typography>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl className={classes.formControl}>
                    <label className={classes.label}>{t("Updated At")}</label>
                    <Typography variant="body2">
                      {this.formatDate(customerData.updatedAt)}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Grid container spacing={3}>
                <Grid item xs={6} sm={6}>
                  <InputFormat
                    required
                    name="customerName"
                    fullWidth={true}
                    value={customerData.customerName}
                    onChange={this.handleChange}
                    label={t("customer_listcustomer_editcustomer_name")}
                    InputLabelProps={{
                      className: classes.rootLabel,
                    }}
                    inputProps={{
                      maxLength: 100,
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <InputFormat
                    name="customerEmail"
                    fullWidth={true}
                    value={customerData.customerEmail}
                    onChange={this.handleChange}
                    label="Email"
                    InputLabelProps={{
                      className: classes.rootLabel,
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <InputFormat
                    label={t(
                      "customer_listcustomer_editcustomer_customer_code"
                    )}
                    name="code"
                    fullWidth={true}
                    value={customerData.code}
                    onChange={this.handleChange}
                    InputLabelProps={{
                      className: classes.disabledRootLabel,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl className={classes.formControl}>
                    <KeyboardDatePicker
                      autoOk
                      disableFuture={true}
                      name="dob"
                      inputVariant="outlined"
                      label={t("customer_listcustomer_editcustomer_birthDay")}
                      format="DD/MM/YYYY"
                      value={customerData.customerBirthDay}
                      views={["year", "month", "date"]}
                      onChange={(date) =>
                        this.handleChangeBirthDay("customerBirthDay", date)
                      }
                      cancelLabel={t("date_picker_cancel")}
                      okLabel={t("date_picker_ok")}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SelectGender
                    fullWidth={true}
                    name="customerGender"
                    label={t("customer_listcustomer_editcustomer_gender")}
                    value={
                      customerData.customerGender
                        ? customerData.customerGender.toLowerCase()
                        : ""
                    }
                    onChange={this.handleChange}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    InputLabelProps={{
                      className: classes.rootLabel,
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <SocialType
                    label="Social Type"
                    name="socialType"
                    value={customerData.socialType}
                    onChange={this.handleChange}
                    SelectProps={{
                      displayEmpty: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <InputFormat
                    label="Social ID"
                    name="socialId"
                    fullWidth={true}
                    value={customerData.socialId}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputFormat
                    label="Social Link"
                    name="socialLink"
                    maxRows={2}
                    value={customerData.socialLink}
                    fullWidth={true}
                    onChange={this.handleChange}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* </Grid> */}
            {/* <Grid item sm={12} md={12}> */}
            {/* <Grid container spacing={3}> */}
            <Grid item xs={6} sm={6}>
              <CountryDropdown
                label={t("customer_addcustomer_country")}
                name="customerCountry"
                priorityOptions={["VN"]}
                whitelist={["VN", "US"]}
                valueType="short"
                variant="outlined"
                blankOptionLabel={t("country")}
                defaultOptionLabel={t("select_country")}
                showDefaultOption={false}
                onChange={this.handleChange}
                value={customerData.customerCountry}
                showDefaultOption={true}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <DistrictDropdown
                label={t("customer_addcustomer_state")}
                variant="outlined"
                country={customerData.customerCountry}
                value={customerData.customerState}
                disabled={customerData.customerCountry !== "US"}
                blankOptionLabel={t("state")}
                defaultOptionLabel={t("select_state")}
                name="customerState"
                onChange={this.onChangeSelect}
                countryValueType="short"
                showDefaultOption={true}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <CityDropdown
                label={t("customer_addcustomer_city")}
                country={customerData.customerCountry}
                variant="outlined"
                value={customerData.customerCity}
                blankOptionLabel={t("city")}
                name="customerCity"
                onChange={this.handleChange}
                defaultOptionLabel={t("select_city")}
                showDefaultOption={true}
                countryValueType="short"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <DistrictDropdown
                label={t("customer_addcustomer_district")}
                country={customerData.customerCountry}
                variant="outlined"
                region={customerData.customerCity}
                value={customerData.customerDistrict}
                blankOptionLabel={t("district")}
                name="customerDistrict"
                countryValueType="short"
                onChange={this.handleChange}
                defaultOptionLabel={t("select_district")}
                showDefaultOption={true}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <WardDropdown
                label={t("ward")}
                country={customerData.customerCountry}
                variant="outlined"
                city={customerData.customerCity}
                region={customerData.customerDistrict}
                value={customerData.customerWard}
                blankOptionLabel={t("ward")}
                defaultOptionLabel={t("select_ward")}
                name="customerWard"
                countryValueType="short"
                onChange={this.handleChange}
                showDefaultOption={true}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <InputFormat
                name="customerAddress"
                fullWidth
                variant="outlined"
                value={customerData.customerAddress}
                onChange={this.handleChange}
                label={t("customer_listcustomer_editcustomer_address")}
                InputLabelProps={{
                  className: classes.rootLabel,
                }}
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <SelectDateTime
                label={t("customer_lastTime")}
                name="lastTime"
                margin="none"
                fullWidth
                value={customerData.lastTime}
                onChange={this.handleChangeDate}
                InputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  className: classes.label,
                }}
                timeFormat="hh:mm A"
                dateFormat="DD/MM/YYYY"
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <InputFormat
                label={t("customer_spentVirtualMoney")}
                name="spentVirtualMoney"
                variant="outlined"
                type="number"
                fullWidth
                value={customerData.spentVirtualMoney}
                onChange={this.handleChangeDate}
                InputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  className: classes.label,
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <InputFormat
                label={t("customer_spentRealMoney")}
                name="spentRealMoney"
                variant="outlined"
                type="number"
                fullWidth
                value={customerData.spentRealMoney}
                onChange={this.handleChangeDate}
                InputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  className: classes.label,
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <InputFormat
                label={t("customer_voucherBalance")}
                name="voucherBalance"
                variant="outlined"
                type="number"
                fullWidth
                value={customerData.voucherBalance}
                onChange={this.handleChangeDate}
                InputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  className: classes.label,
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <InputFormat
                label={t("customer_voucherMoney")}
                name="voucherMoney"
                variant="outlined"
                type="number"
                fullWidth
                value={customerData.voucherMoney}
                onChange={this.handleChangeDate}
                InputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  className: classes.label,
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <InputFormat
                label={t("customer_balance")}
                name="balance"
                variant="outlined"
                type="number"
                fullWidth
                value={customerData.balance}
                onChange={this.handleChangeDate}
                InputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  className: classes.label,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <SelectMultiInteresting
                label={t("customer_interesting")}
                placeholder={t("customer_useSerives_placeholder")}
                name="interesting"
                handleGetValue={this.handleGetValueInteresting}
                suggestions={allMenuItem.map((e) => {
                  return {
                    label: e.title,
                    value: {
                      menuId: e.menuId,
                      menuItemId: e.itemCode,
                      totalMoney: e.price,
                      label: e.title,
                    },
                  };
                })}
                defaultValue={customerData.interesting}
                InputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  className: classes.label,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <SelectMultiUsedService
                label={t("customer_useSerives")}
                placeholder={t("customer_useSerives_placeholder")}
                name="useServices"
                handleGetValue={this.handleGetValueUsedService}
                suggestions={allMenuItem.map((e) => {
                  return {
                    label: e.title,
                    value: {
                      menuId: e.menuId,
                      menuItemId: e.itemCode,
                      totalMoney: e.price,
                      label: e.title,
                      quantity: 1,
                    },
                  };
                })}
                defaultValue={customerData.useServices}
                InputProps={{
                  className: classes.input,
                }}
                InputLabelProps={{
                  className: classes.label,
                }}
              />
            </Grid>
            {/* </Grid> */}
            {/* </Grid> */}
          </Grid>
          <div className={classes.wrapButton}>
            <Link to={"/customer/" + customerData._id}>
              <Button
                variant="contained"
                color="primary"
                className={classes.wrapButtonReport}
                classes={{ containedPrimary: classes.colorButtonViewReport }}
              >
                {t("customer_listcustomer_editcustomer_view_report")}
              </Button>
            </Link>
            <Button
              variant="contained"
              color="secondary"
              classes={{ containedSecondary: classes.colorButtonSave }}
              onClick={this.handleCheck}
            >
              {t("customer_listcustomer_editcustomer_save")}
            </Button>
          </div>
        </Paper>
      </MuiPickersUtilsProvider>
    );
  }
}

EditForm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  allMenuItem: state.serviceMenuItem.allMenuItem || [],
});

const mapDispatch = (dispatch) => ({
  customerDispatch: dispatch.customer,
  uploadDispatch: dispatch.upload,
  getAllMenuItem: dispatch.serviceMenuItem.getAllMenuItem,
  getVoucher: dispatch.voucher.getVoucher,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(EditForm)));
